import Vue from 'vue';
import AxiosPlugin from './js/lib/axiosPlugin';
import API from './js/interface/index';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/quill.bubble.css'
import './assets/css/quill.core.css'
import './assets/css/quill.snow.css'
import './assets/icon/iconfont.css'     //引入阿里巴巴iconfont
import NProgress from 'nprogress';      //引入全局页面渲染进度组件
import 'nprogress/nprogress.css';
import Router from 'vue-router';
import routes from './router';
import App from './App';

// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/swiper-bundle.css'

Vue.use(AxiosPlugin);
Vue.use(ElementUI);
// Vue.use(VueAwesomeSwiper) 

const bus = new Vue()
Vue.prototype.$bus = bus

// 过滤器
import filters from "./js/lib/filters";

// 过滤器统一加载处理
for (let key in filters) {
    Vue.filter(key, filters[key]);
}

Vue.config.productionTip = false;

Vue.prototype._isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);

//处理路由重复访问
const originalPush = Router.prototype.push
    Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes,
     scrollBehavior (to, from, savedPosition) {
        // 路由切换，简单的让页面滚动到顶部
        return { x: 0, y: 0 }
    }
});


// console.log(window.env);
window.API = API;//把引入统一管理接口页面挂在全局对象window.API下面

//过滤不需要验证的路由
let filterRouter = ['/center/dataBoard'];
// 设置全局token监听定时器
window['timeCounter']  = null;
function time () {
    window['timeCounter'] = setInterval(() => {
        if(!localStorage.getItem('token')) {
            ElementUI.MessageBox.alert('登录已失效，请重新登录!', {
                type: 'error', 
                onClose: () => {
                    window.location.href = '/login';
                }
            });
            clearInterval(window['timeCounter']);
            window['timeCounter'] = null;
        }
    }, 5000);
};

router.beforeEach((to, from, next) => {
    NProgress.start();
    // 开启定时器
    if(to.fullPath !== '/login' && to.meta['requiresAuth'] && !window['timeCounter']) {
        time()
    }
    //判断路由是否需要登录
    if(to.matched.some(record => record.meta.requiresAuth)) {
        if (!localStorage.getItem('token') && !sessionStorage.getItem('token')) {
            //登陆后，调回原来刚刚访问的页面
            next({
                path: '/login',
                query: {redirect: to.fullPath}
            }); 
        } else {
            next();
        }
    } else {
        //访问登录页面，如果带token则跳转首页
        if(to.fullPath === '/login') {
            if(localStorage.getItem('token') || sessionStorage.getItem('token')) {
                next({path: '/'});
            }else {
                next();
            }
        }else {
            next();
        }
    }
});

router.afterEach(() => {
    // ElementUI.MessageBox.alert('登录已失效，请重新登录!', {
    //     type: 'error'
    // });
    NProgress.done();
});

new Vue({
    el: '#app',
    router,
    render: h => h(App)
});


// WEBPACK FOOTER //
// ./src/main.js